import React, { useEffect, useRef, useState } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import {
  validaSoloNumero
} from '../../util/varios';
import { Mensaje, MensajeSiNo } from '../mensajes';
import moment from 'moment';
import CatalogoAlmacen from '../../catalogos/catalogoAlmacen';
import CatalogoCliente from '../../catalogos/catalogoCliente';

export const ImprimirNotasdeDebitos = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  const fechasistema = JSON.parse(sessionStorage.getItem('fechasistema'));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtTodasFechas = useRef();
  const txtPorFechas = useRef();
  const txtTodosDispo = useRef();
  const txtCanceladas = useRef();
  const txtDeudas = useRef();
  const txtAnuladas = useRef();
  const txtTodosCliente = useRef();
  const txtPorCliente = useRef();
  const txtIdProducto = useRef();
  const txtRifrespon = useRef();
  const txtNomrespon = useRef();
  const txtRifVende = useRef();
  const txtNomVende = useRef();
  const txtDesde = useRef();
  const txtHasta = useRef();
  const txtCbmrif = useRef();
  const txtCbmrifVende = useRef();
  const txtTodosAlmacen = useRef();
  const txtPorAlmacen = useRef();
  const txtCodigoAlmacen = useRef();
  const txtNombreAlmacen = useRef();
  const txtOrden = useRef();
  const txtTodosVendedores = useRef();
  const txtPorVendedor = useRef();
  const txtChekGeneral = useRef();
  const txtTodosEstados = useRef();
  const txtPorEstados = useRef();
  const txtEstado = useRef();
  const txtMunicipio = useRef();
  const txtCiudad = useRef();

  const [inputalmacen, setInputalmacen] = useState(0);
  const [tipon, setTipon] = useState('');
  const [inputproducto, setInputproducto] = useState(0);
  const [valvende, setValvende] = useState(0);
  const [tiporif, setTipofic] = useState(null);
  const [tituloc, setTituloc] = useState('');
  const [mostrar1, setMostrar1] = useState(null);
  const [mostrar2, setMostrar2] = useState(null);
  const [parafecha, setParafecha] = useState('');
  const [desde, setDesde] = useState('');
  const [hasta, setHasta] = useState('');
  const [ordens, setOrdens] = useState('');
  const [idestadoc, setIdestadoc] = useState(null);
  const [idmunicipioc, setIdmunicipioc] = useState(null);
  const [idciudadc, setIdciudadc] = useState(null);
  const [clientvende, setClientvende] = useState('');
  const [disponiblec, setDisponiblec] = useState('');
  const [paracliente, setParacliente] = useState('');
  const [idclient, setIdclient] = useState('');
  const [valestado, setValestado] = useState(0);
  const [idvendedr, setIdvendedr] = useState('');
  const [report, setReport] = useState('');
  const [idalmacen, setIdalmacen] = useState(null);
  const [valalmacen, setValalmacen] = useState(null);
  const [activate, setActivate] = useState(false);
  const [idsc, setIdsc] = useState([]);
  const [habilitado, setHabilitado] = useState(true);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [tituid, setTituid] = useState('');
  const [estado, setEstado] = useState([]);
  const [municipio, setMunicipio] = useState([]);
  const [ciudad, setCiudad] = useState([]);
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    salir: false
  });

  const blanquear = () => {
    setActivate(false);
    setInputalmacen(0);
    setParafecha('');
    setDisponiblec('');
    setParacliente('');
    setInputproducto(0);
    setIdalmacen("");
    setReport('');
    setIdclient('');
    setIdvendedr('');
    setValalmacen(0);
    setOrdens('');
    setValvende(0);
    setValestado(0);
    setTipon('');
  }

  const cancelar = () => {
    blanquear();
    props.onHideCancela();

  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    let sigue = true;
    if (props.op === 1) {

      if (txtPorFechas.current.checked === true && txtPorCliente.current.checked === false) {
        if (txtDesde.current.value === '' || txtHasta.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione las Fechas a Consultar !', icono: 'informacion' });
          if (txtDesde.current.value === '' && txtHasta.current.value !== '') {
            txtDesde.current.focus()
          } else if (txtHasta.current.value === '' && txtDesde.current.value !== '') {
            txtHasta.current.focus()
          }
          sigue = false
        } else {
          imprimirGeneral();
        }

      } else if (txtPorFechas.current.checked === false && txtPorCliente.current.checked === true) {
        if (txtRifrespon.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Cliente a Consultar !', icono: 'informacion' });
          txtRifrespon.current.focus()
          sigue = false
        } else {
          imprimirGeneral();
        }
      } else if (txtPorFechas.current.checked === true && txtPorCliente.current.checked === true) {
        if (txtDesde.current.value === '' || txtHasta.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Las Fechas a Consultar no Deben ir Vacias !', icono: 'informacion' });
          txtPorFechas.current.focus()
          sigue = false
        } else if (txtRifrespon.current.value === '') {
          setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el RIF del Cliente a Consultar !', icono: 'informacion' });
          txtRifrespon.current.focus()
          sigue = false
        } else {
          imprimirGeneral();
        }
      } else {
        imprimirGeneral();
      }

    }

  }

  const seleccionarRegistro = () => {
    const campos = "estado,municipio,ciudad";
    const nomtab = "organizacion";
    const endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=rif&id=${afiliado}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            selectEstado(data.estado);
            selectMunicipios(data.estado, () => {
              if (txtMunicipio.current) {
                txtMunicipio.current.value = data.municipio;
                selectCiudad(data.municipio, () => {
                  if (txtCiudad.current) {
                    txtCiudad.current.value = data.ciudad;
                    if (valestado === 1) {
                      seleccionarClient();
                    }
                  }
                });
              }
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectEstado = (id) => {
    let campos = "*";
    let nomtab = "estado";
    let nomid = "idestado";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setEstado([response.data]);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectMunicipios = (id, callback) => {
    let campos = "*";
    let nomtab = "municipio";
    let nomid = "idestado";
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMunicipio(response.data);
          if (callback) callback();
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectCiudad = (id, callback) => {
    let campos = "*";
    let nomtab = "ciudad";
    let nomid = "idmunicipio";
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setCiudad(response.data);
          if (callback) callback();
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleMunicipioChange = () => {
    if (txtMunicipio.current && txtMunicipio.current.value && valestado === 1) {
      const idMunicipio = txtMunicipio.current.value;
      selectCiudad(idMunicipio, () => {
        if (txtCiudad.current) {
          txtCiudad.current.value = '';
        }
        txtRifrespon.current.value = '';
        txtNomrespon.current.value = '';
        setIdclient('');
        setParacliente('');
      });
    }
  };

  const handleCiudadChange = () => {
    if (txtCiudad.current && txtCiudad.current.value && valestado === 1 && txtMunicipio.current && txtMunicipio.current.value) {
      txtRifrespon.current.value = '';
      txtNomrespon.current.value = '';
      setIdclient('');
      setParacliente('');
      seleccionarClient();
    }
  };

  useEffect(() => {
    if (txtMunicipio.current) {
      const handleChange = () => {
        if (valestado === 1) {
          const idMunicipio = txtMunicipio.current.value;
          if (idMunicipio) {
            selectCiudad(idMunicipio, () => {
              if (txtCiudad.current) {
                txtCiudad.current.value = '';
              }
              txtRifrespon.current.value = '';
              txtNomrespon.current.value = '';
              setIdclient('');
              setParacliente('');
            });
          }
        }
      };
      txtMunicipio.current.addEventListener('change', handleChange);
      return () => {
        if (txtMunicipio.current) {
          txtMunicipio.current.removeEventListener('change', handleChange);
        }
      };
    }
  }, [valestado, municipio]);

  useEffect(() => {
    if (txtCiudad.current) {
      const handleChange = () => {
        if (valestado === 1 && txtCiudad.current.value && txtMunicipio.current && txtMunicipio.current.value) {
          txtRifrespon.current.value = '';
          txtNomrespon.current.value = '';
          setIdclient('');
          setParacliente('');
          seleccionarClient();
        }
      };

      txtCiudad.current.addEventListener('change', handleChange);
      return () => {
        if (txtCiudad.current) {
          txtCiudad.current.removeEventListener('change', handleChange);
        }
      };
    }
  }, [valestado, ciudad]);

  const onChekval = (e) => {

    if (e.target.id === 'tipoalmacen') {
      if (txtTodasFechas.current.checked === true) {
        setInputalmacen(0);
        setParafecha('');
        setDesde('');
        setHasta('');
        txtDesde.current.value = '';
        txtHasta.current.value = '';
        if (txtTodosCliente.current.checked === true && txtTodosDispo.current.checked === true && txtTodosAlmacen.current.checked === true &&
          txtTodosVendedores.current.checked === true && txtTodosEstados.current.checked === true) {
          setValestado(0);
          if (props.report === "reportenotaentrega") {
            let tipo = 'NE';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
            setTituloc('LISTADO DE NOTAS DE ENTREGA');
            setTituid(tipo);
          } else if (props.report === "reportenotadebitos") {
            let tipo = 'ND';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
            setTituloc('LISTADO DE NOTAS DE DEBITO');
            setTituid(tipo);
          } else if (props.report === "reporteobsequio") {
            let tipo = 'NO';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
          } else if (props.report === "reportepedidos") {
            let paran = 'and n.idcliente > 0';
            setReport("'" + paran + "'");
            setTituid('PE');
            setTituloc('LISTADO DE PEDIDOS GENERADOS');
          } else if (props.report === "reportefacturas") {
            setReport("'" + 'n.idfactura > 0 ' + "'");
          }
        } else {
          if (props.report === "reportenotaentrega") {
            let tipo = 'NE';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
            setTituloc('LISTADO DE NOTAS DE ENTREGA');
            setTituid(tipo);
          } else if (props.report === "reportenotadebitos") {
            let tipo = 'ND';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
            setTituloc('LISTADO DE NOTAS DE DEBITO');
            setTituid(tipo);
          } else if (props.report === "reporteobsequio") {
            let tipo = 'NO';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
          } else if (props.report === "reportepedidos") {
            setReport('');
            setTituid('PE');
            setTituloc('LISTADO DE PEDIDOS GENERADOS');
          } else if (props.report === "reportefacturas") {
            setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
          }
        }
      } else if (txtPorFechas.current.checked === true) {
        setInputalmacen(1);
        setParafecha("'" + ' and n.fecha between ' + "'");
        if (props.report === "reportenotaentrega") {
          let tipo = 'NE';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE NOTAS DE ENTREGA');
          setTituid(tipo);
        } else if (props.report === "reportenotadebitos") {
          let tipo = 'ND';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE NOTAS DE DEBITO');
          setTituid(tipo);
        } else if (props.report === "reporteobsequio") {
          let tipo = 'NO';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
        } else if (props.report === "reportepedidos") {
          setReport('');
          setTituid('PE');
          setTituloc('LISTADO DE PEDIDOS GENERADOS');
        } else if (props.report === "reportefacturas") {
          setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
        }

      }
    } else if (e.target.id === 'tipodisponible') {
      if (e.target.value === '1') {
        setDisponiblec('');
        if (txtTodosCliente.current.checked === true && txtTodasFechas.current.checked === true && txtTodosAlmacen.current.checked === true &&
          txtTodosVendedores.current.checked === true && txtTodosEstados.current.checked === true) {
          setValestado(0);
          if (props.report === "reportenotaentrega") {
            let tipo = 'NE';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
            setTituloc('LISTADO DE NOTAS DE ENTREGA');
            setTituid(tipo);
          } else if (props.report === "reportenotadebitos") {
            let tipo = 'ND';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
            setTituloc('LISTADO DE NOTAS DE DEBITO');
            setTituid(tipo);
          } else if (props.report === "reporteobsequio") {
            let tipo = 'NO';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
          } else if (props.report === "reportepedidos") {
            let paran = 'and n.idcliente > 0';
            setReport("'" + paran + "'");
            setTituid('PE');
            setTituloc('LISTADO DE PEDIDOS GENERADOS');
          } else if (props.report === "reportefacturas") {
            setReport("'" + 'n.idfactura > 0 ' + "'");
          }
        } else {
          if (props.report === "reportenotaentrega") {
            let tipo = 'NE';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
            setTituloc('LISTADO DE NOTAS DE ENTREGA');
            setTituid(tipo);
          } else if (props.report === "reportenotadebitos") {
            let tipo = 'ND';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
            setTituloc('LISTADO DE NOTAS DE DEBITO');
            setTituid(tipo);
          } else if (props.report === "reporteobsequio") {
            let tipo = 'NO';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
          } else if (props.report === "reportepedidos") {
            setReport('');
            setTituid('PE');
            setTituloc('LISTADO DE PEDIDOS GENERADOS');
          } else if (props.report === "reportefacturas") {
            setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
          }
        }
      } else if (e.target.value === '2') {
        setValestado(0);
        setDisponiblec("'" + ' and n.status = 1' + "'");
        if (props.report === "reportenotaentrega") {
          let tipo = 'NE';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE NOTAS DE ENTREGA');
          setTituid(tipo);
        } else if (props.report === "reportenotadebitos") {
          let tipo = 'ND';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE NOTAS DE DEBITO');
          setTituid(tipo);
        } else if (props.report === "reporteobsequio") {
          let tipo = 'NO';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
        } else if (props.report === "reportepedidos") {
          setReport('');
          setTituid('PE');
          setTituloc('LISTADO DE PEDIDOS GENERADOS');
        } else if (props.report === "reportefacturas") {
          setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
        }
      } else if (e.target.value === '3') {
        setDisponiblec("'" + ' and n.status = 0' + "'");
        setValestado(0);
        if (props.report === "reportenotaentrega") {
          let tipo = 'NE';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE NOTAS DE ENTREGA');
          setTituid(tipo);
        } else if (props.report === "reportenotadebitos") {
          let tipo = 'ND';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE NOTAS DE DEBITO');
          setTituid(tipo);
        } else if (props.report === "reporteobsequio") {
          let tipo = 'NO';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
        } else if (props.report === "reportepedidos") {
          setReport('');
          setTituid('PE');
          setTituloc('LISTADO DE PEDIDOS GENERADOS');
        } else if (props.report === "reportefacturas") {
          setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
        }
      } else if (e.target.value === '4') {
        setValestado(0);
        setDisponiblec("'" + ' and n.status = 4' + "'");
        if (props.report === "reportenotaentrega") {
          let tipo = 'NE';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE NOTAS DE ENTREGA');
          setTituid(tipo);
        } else if (props.report === "reportenotadebitos") {
          let tipo = 'ND';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE NOTAS DE DEBITO');
          setTituid(tipo);
        } else if (props.report === "reporteobsequio") {
          let tipo = 'NO';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
        } else if (props.report === "reportepedidos") {
          setReport('');
          setTituid('PE');
          setTituloc('LISTADO DE PEDIDOS GENERADOS');
        } else if (props.report === "reportefacturas") {
          setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
        }
      }
    } else if (e.target.id === 'cliente') {
      if (txtTodosCliente.current.checked === true) {
        setInputproducto(0);
        setParacliente('');
        setIdclient('');
        setValestado(0);
        txtNomrespon.current.value = '';
        txtCbmrif.current.value = '';
        txtRifrespon.current.value = '';
        if (txtTodasFechas.current.checked === true && txtTodosDispo.current.checked === true && txtTodosAlmacen.current.checked === true &&
          txtTodosVendedores.current.value === true) {
          if (props.report === "reportenotaentrega") {
            let tipo = 'NE';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
            setTituloc('LISTADO DE NOTAS DE ENTREGA');
            setTituid(tipo);
          } else if (props.report === "reportenotadebitos") {
            let tipo = 'ND';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
            setTituloc('LISTADO DE NOTAS DE DEBITO');
            setTituid(tipo);
          } else if (props.report === "reporteobsequio") {
            let tipo = 'NO';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
          } else if (props.report === "reportepedidos") {
            let paran = 'and n.idcliente > 0';
            setReport("'" + paran + "'");
            setTituid('PE');
            setTituloc('LISTADO DE PEDIDOS GENERADOS');
          } else if (props.report === "reportefacturas") {
            setReport("'" + 'n.idfactura > 0 ' + "'");
          }
        } else {
          if (props.report === "reportenotaentrega") {
            let tipo = 'NE';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
            setTituloc('LISTADO DE NOTAS DE ENTREGA');
            setTituid(tipo);
          } else if (props.report === "reportenotadebitos") {
            let tipo = 'ND';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
            setTituloc('LISTADO DE NOTAS DE DEBITO');
            setTituid(tipo);
          } else if (props.report === "reporteobsequio") {
            let tipo = 'NO';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
          } else if (props.report === "reportepedidos") {
            setReport('');
            setTituid('PE');
            setTituloc('LISTADO DE PEDIDOS GENERADOS');
          } else if (props.report === "reportefacturas") {
            setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
          }
        }
      } else if (txtPorCliente.current.checked === true) {
        setInputproducto(1);
        setParacliente("'" + ' and n.cedularif =' + "'");
        setValestado(0);
        if (props.report === "reportenotaentrega") {
          let tipo = 'NE';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE NOTAS DE ENTREGA');
          setTituid(tipo);
        } else if (props.report === "reportenotadebitos") {
          let tipo = 'ND';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE NOTAS DE DEBITO');
          setTituid(tipo);
        } else if (props.report === "reporteobsequio") {
          let tipo = 'NO';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
        } else if (props.report === "reportepedidos") {
          setReport('');
          setTituid('PE');
          setTituloc('LISTADO DE PEDIDOS GENERADOS');
        } else if (props.report === "reportefacturas") {
          setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
        }
      }
    } else if (e.target.id === 'alamcen') {
      if (txtTodosAlmacen.current.checked === true) {
        setValestado(0);
        txtCodigoAlmacen.current.value = '';
        txtNombreAlmacen.current.value = '';
        if (props.report === "reporteobsequio") {
          if (txtTodasFechas.current.checked === true && txtTodosCliente.current.checked === true &&
            txtTodosVendedores.current.checked === true && txtTodosEstados.current.checked === true) {
            setValestado(0);
            if (props.report === "reportenotaentrega") {
              let tipo = 'NE';
              let paran = 'n.tipo = ';
              setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
              setTituloc('LISTADO DE NOTAS DE ENTREGA');
              setTituid(tipo);
            } else if (props.report === "reportenotadebitos") {
              let tipo = 'ND';
              let paran = 'n.tipo = ';
              setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
              setTituloc('LISTADO DE NOTAS DE DEBITO');
              setTituid(tipo);
            } else if (props.report === "reporteobsequio") {
              let tipo = 'NO';
              let paran = 'n.tipo = ';
              setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
              setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
            } else if (props.report === "reportepedidos") {
              let paran = 'and n.idcliente > 0';
              setReport("'" + paran + "'");
              setTituid('PE');
              setTituloc('LISTADO DE PEDIDOS GENERADOS');
            } else if (props.report === "reportefacturas") {
              setReport("'" + 'n.idfactura > 0 ' + "'");
            }
          } else {
            if (props.report === "reportenotaentrega") {
              let tipo = 'NE';
              let paran = 'n.tipo = ';
              setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
              setTituloc('LISTADO DE NOTAS DE ENTREGA');
              setTituid(tipo);
            } else if (props.report === "reportenotadebitos") {
              let tipo = 'ND';
              let paran = 'n.tipo = ';
              setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
              setTituloc('LISTADO DE NOTAS DE DEBITO');
              setTituid(tipo);
            } else if (props.report === "reporteobsequio") {
              let tipo = 'NO';
              let paran = 'n.tipo = ';
              setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
              setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
            } else if (props.report === "reportepedidos") {
              setReport('');
              setTituid('PE');
              setTituloc('LISTADO DE PEDIDOS GENERADOS');
            } else if (props.report === "reportefacturas") {
              setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
            }
          }
        } else {
          if (txtTodasFechas.current.checked === true && txtTodosDispo.current.checked === true && txtTodosCliente.current.checked === true &&
            txtTodosVendedores.current.checked === true && txtTodosEstados.current.checked === true) {
            if (props.report === "reportenotaentrega") {
              let tipo = 'NE';
              let paran = 'n.tipo = ';
              setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
              setTituloc('LISTADO DE NOTAS DE ENTREGA');
              setTituid(tipo);
            } else if (props.report === "reportenotadebitos") {
              let tipo = 'ND';
              let paran = 'n.tipo = ';
              setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
              setTituloc('LISTADO DE NOTAS DE DEBITO');
              setTituid(tipo);
            } else if (props.report === "reporteobsequio") {
              let tipo = 'NO';
              let paran = 'n.tipo = ';
              setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
              setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
            } else if (props.report === "reportepedidos") {
              let paran = 'and n.idcliente > 0';
              setReport("'" + paran + "'");
              setTituid('PE');
              setTituloc('LISTADO DE PEDIDOS GENERADOS');
            } else if (props.report === "reportefacturas") {
              setReport("'" + 'n.idfactura > 0 ' + "'");
            }
          } else {
            if (props.report === "reportenotaentrega") {
              let tipo = 'NE';
              let paran = 'n.tipo = ';
              setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
              setTituloc('LISTADO DE NOTAS DE ENTREGA');
              setTituid(tipo);
            } else if (props.report === "reportenotadebitos") {
              let tipo = 'ND';
              let paran = 'n.tipo = ';
              setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
              setTituloc('LISTADO DE NOTAS DE DEBITO');
              setTituid(tipo);
            } else if (props.report === "reporteobsequio") {
              let tipo = 'NO';
              let paran = 'n.tipo = ';
              setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
              setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
            } else if (props.report === "reportepedidos") {
              setReport('');
              setTituid('PE');
              setTituloc('LISTADO DE PEDIDOS GENERADOS');
            } else if (props.report === "reportefacturas") {
              setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
            }
          }
        }
      } else if (txtPorAlmacen.current.checked === true) {
        setValalmacen(1);
        if (props.report === "reportenotaentrega") {
          let tipo = 'NE';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE NOTAS DE ENTREGA');
          setTituid(tipo);
        } else if (props.report === "reportenotadebitos") {
          let tipo = 'ND';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE NOTAS DE DEBITO');
          setTituid(tipo);
        } else if (props.report === "reporteobsequio") {
          let tipo = 'NO';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
        } else if (props.report === "reportepedidos") {
          setReport('');
          setTituid('PE');
          setTituloc('LISTADO DE PEDIDOS GENERADOS');
        } else if (props.report === "reportefacturas") {
          setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
        }
      }
    } else if (e.target.id === 'vendedor') {
      if (txtTodosVendedores.current.checked === true) {
        setValvende(0);
        setIdvendedr('');
        txtCbmrifVende.current.value = '';
        txtNomVende.current.value = '';
        txtRifVende.current.value = '';
        if (txtTodasFechas.current.checked === true && txtTodosDispo.current.checked === true && txtTodosAlmacen.current.checked === true &&
          txtTodosCliente.current.checked === true && txtTodosEstados.current.checked === true) {
          setValestado(0);
          if (props.report === "reportenotaentrega") {
            let tipo = 'NE';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
            setTituloc('LISTADO DE NOTAS DE ENTREGA');
            setTituid(tipo);
          } else if (props.report === "reportenotadebitos") {
            let tipo = 'ND';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
            setTituloc('LISTADO DE NOTAS DE DEBITO');
            setTituid(tipo);
          } else if (props.report === "reporteobsequio") {
            let tipo = 'NO';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
          } else if (props.report === "reportepedidos") {
            let paran = 'and n.idcliente > 0';
            setReport("'" + paran + "'");
            setTituid('PE');
            setTituloc('LISTADO DE PEDIDOS GENERADOS');
          } else if (props.report === "reportefacturas") {
            setReport("'" + 'n.idfactura > 0 ' + "'");
          }
        } else {
          if (props.report === "reportenotaentrega") {
            let tipo = 'NE';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
            setTituloc('LISTADO DE NOTAS DE ENTREGA');
            setTituid(tipo);
          } else if (props.report === "reportenotadebitos") {
            let tipo = 'ND';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
            setTituloc('LISTADO DE NOTAS DE DEBITO');
            setTituid(tipo);
          } else if (props.report === "reporteobsequio") {
            let tipo = 'NO';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
          } else if (props.report === "reportepedidos") {
            setReport('');
            setTituid('PE');
            setTituloc('LISTADO DE PEDIDOS GENERADOS');
          } else if (props.report === "reportefacturas") {
            setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
          }
        }
      } else if (txtPorVendedor.current.checked === true) {
        setValvende(1);
        if (props.report === "reportenotaentrega") {
          let tipo = 'NE';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE NOTAS DE ENTREGA');
          setTituid(tipo);
        } else if (props.report === "reportenotadebitos") {
          let tipo = 'ND';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE NOTAS DE DEBITO');
          setTituid(tipo);
        } else if (props.report === "reporteobsequio") {
          let tipo = 'NO';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
        } else if (props.report === "reportepedidos") {
          setReport('');
          setTituid('PE');
          setTituloc('LISTADO DE PEDIDOS GENERADOS');
        } else if (props.report === "reportefacturas") {
          setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
        }
      }
    } else if (e.target.name === 'estado') {
      if (txtTodosEstados.current.checked === true) {
        setValestado(0);
        setParacliente('');
        if (txtTodasFechas.current.checked === true && txtTodosDispo.current.checked === true && txtTodosAlmacen.current.checked === true &&
          txtTodosVendedores.current.checked === true && txtTodosCliente.current.checked === true) {
          setInputproducto(0);
          if (txtMunicipio.current) txtMunicipio.current.value = '';
          if (txtCiudad.current) txtCiudad.current.value = '';
          setCiudad([]);
          if (props.report === "reportenotaentrega") {
            let tipo = 'NE';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
            setTituloc('LISTADO DE NOTAS DE ENTREGA');
            setTituid(tipo);
          } else if (props.report === "reportenotadebitos") {
            let tipo = 'ND';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
            setTituloc('LISTADO DE NOTAS DE DEBITO');
            setTituid(tipo);
          } else if (props.report === "reporteobsequio") {
            let tipo = 'NO';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
          } else if (props.report === "reportepedidos") {
            let paran = 'and n.idcliente > 0';
            setReport("'" + paran + "'");
            setTituid('PE');
            setTituloc('LISTADO DE PEDIDOS GENERADOS');
          } else if (props.report === "reportefacturas") {
            setReport("'" + 'n.idfactura > 0 ' + "'");
          }
        } else {
          if (props.report === "reportenotaentrega") {
            let tipo = 'NE';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
            setTituloc('LISTADO DE NOTAS DE ENTREGA');
            setTituid(tipo);
          } else if (props.report === "reportenotadebitos") {
            let tipo = 'ND';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
            setTituloc('LISTADO DE NOTAS DE DEBITO');
            setTituid(tipo);
          } else if (props.report === "reporteobsequio") {
            let tipo = 'NO';
            let paran = 'n.tipo = ';
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
          } else if (props.report === "reportepedidos") {
            setReport('');
            setTituid('PE');
            setTituloc('LISTADO DE PEDIDOS GENERADOS');
          } else if (props.report === "reportefacturas") {
            setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
          }
        }
      } else if (txtPorEstados.current.checked === true) {
        setValestado(1);
        setInputproducto(0);
        txtRifrespon.current.value = '';
        txtNomrespon.current.value = '';
        setParacliente('');
        setIdclient('');
        seleccionarClient();
        if (props.report === "reportenotaentrega") {
          let tipo = 'NE';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE NOTAS DE ENTREGA');
          setTituid(tipo);
        } else if (props.report === "reportenotadebitos") {
          let tipo = 'ND';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE NOTAS DE DEBITO');
          setTituid(tipo);
        } else if (props.report === "reporteobsequio") {
          let tipo = 'NO';
          let paran = 'n.tipo = ';
          setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ") ||");
          setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
        } else if (props.report === "reportepedidos") {
          setReport('');
          setTituid('PE');
          setTituloc('LISTADO DE PEDIDOS GENERADOS');
        } else if (props.report === "reportefacturas") {
          setReport("'" + 'n.idfactura > 0 ' + "'" + '||');
        }
      }
    }
  }

  const imprimirGeneral = () => {

    let parameters;
    let validacion = "";
    let validados = "";
    let validates = "";
    let validauno = "";
    let validacuatro = "";
    let valstd = paracliente !== '' ? 1 : 0;
    let valst = valvende && valalmacen !== '' ? 1 : paracliente !== '' ? 1 : 0;

    let almacen = "";
    if (valalmacen === 1) {
      if (props.report !== 'reportenotadebitos') {
        almacen = "'" + 'and n.idalmacen = ' + idalmacen + "'";
      } else {
        almacen = '';
      }
    } else {
      almacen = '';
    }

    if (inputalmacen === 1) {
      parameters = "|| quote_literal(" + desde + ") ||" + "'" + ' and ' + "'" + "|| quote_literal(" + hasta + ")";
      validacion = disponiblec || almacen || idclient || idvendedr !== '' ? '||' : '';
    } else {
      parameters = '';
      validacion = '';
    }

    if (inputproducto === 1) {
      validates = paracliente !== '' ? '||' : '';
    } else if (valestado === 1) {
      validates = valstd === 1 && valst !== 0 && parameters.length > 0 ? '||' : '';
    } else {
      validates = '';
    }

    if (valvende === 1) {
      validacuatro = paracliente && idclient !== '' ? '||' : '';
    } else {
      validacuatro = '';
    }

    if (props.report !== "reporteobsequio") {

      if (txtTodosDispo.current.checked === true) {
        validados = '';
      } else {
        validados = disponiblec && almacen !== '' || disponiblec && paracliente !== '' || idvendedr !== '' ? '||' : '';
      }

      if (props.report !== 'reportenotadebitos') {
        if (txtTodosAlmacen.current.checked === true) {
          validauno = '';
        } else {
          validauno = idvendedr || almacen && paracliente !== '' ? '||' : '';
        }
      }

    }

    var reporte = "";
    let numtabla = "";

    if (props.report === "reportenotaentrega" || props.report === "reportepedidos") {

      if (txtChekGeneral.current.checked === true) {
        reporte = "ReporteNEntregaGeneral";
      } else {
        reporte = "ReporteDebitos";
      }

      if (props.report === "reportenotaentrega") {
        numtabla = 'n.numnotaentrega';
      } else {
        numtabla = 'n.numpedido';
      }

    } else if (props.report === "reporteobsequio") {
      reporte = "ReporteObsequioDonacion";
    } else if (props.report === 'reportefacturas') {
      reporte = "ReporteFacturasDos";
      numtabla = 'n.numfactura';
    } else if (props.report === 'reportenotadebitos') {
      reporte = "ReporteDebitosDos";
      numtabla = 'n.numnotaentrega';
    }

    let condi = valestado !== 1 ? report + disponiblec + validados + almacen + validauno + paracliente + validates + idclient + validacuatro + idvendedr + validacion + parafecha + parameters
      : report + disponiblec + validados + almacen + validauno + paracliente + validates + validacuatro + idvendedr + validacion + parafecha + parameters;
    let orden = txtChekGeneral.current.checked === true ? "n.idcliente, n.fecha" :
      txtOrden.current.value === '1' ? ordens + ", " + numtabla : ordens + ", " + numtabla + ", " + txtOrden.current.value;

    let ope = 0;
    if (props.report === "reportenotaentrega" || props.report === 'reportenotadebitos') {
      if (txtChekGeneral.current.checked === true) {
        ope = 2;
      } else {
        ope = 1;
      }
    } else if (props.report === "reportepedidos") {
      ope = 2;
    } else if (props.report === "reportefacturas") {
      ope = 3;
    } else if (props.report === "reporteobsequio") {
      ope = 1;
    }
    window.open(op.reportes + "/ventas?afiliado=" + afiliado + "&reporte=" + reporte + "&condicion=" + condi + "&titulo=" + tituloc + "&tiid=" + tituid + "&orden=" + orden + "&ope=" + ope, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
  }

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });

  };

  const cerrarModal = () => {
    if (props.llamado === 2) {
      props.onHideRenderizar();
      props.onHideCancela();
    }
    blanquear();
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
  }

  const seleccionarClient = () => {

    let campos = 'idagente';
    let nomtab = 'agente';
    let condi = "cliente = true and municipio = '" + txtMunicipio.current.value + "'" + " and ciudad = '" + txtCiudad.current.value + "'";
    let orden = 'idagente';

    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?&campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    setActivate(true);

    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {
        if (response.data.length > 0) {
          let ids = [];
          for (let i = 0; i < response.data.length; i++) {
            ids.push(parseInt(response.data[i].idagente));
          }
          setParacliente("'" + ' and n.idcliente in(' + ids + ')' + "'");
          setIdsc(ids)
        }
      } else {
      }
    }).catch(function (error) {
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
      setActivate(false);
    }).finally(() => {
      setActivate(false);
    })
  }

  const handleAceptaCliente = (values) => {
    setMostrar1(false);
    if (clientvende === 'cliente') {
      txtCbmrif.current.value = values.rif.substring(0, 1);
      txtRifrespon.current.value = values.rif.substring(2, 9);
      txtNomrespon.current.value = values.nombre;
      selectResponsable(values.rif);
      if (txtPorEstados.current.checked) {

      } else {
        setIdclient("quoete_literal(" + "'" + values.rif + "'" + ")");
      }
    } else if (clientvende === 'vendedor') {
      txtCbmrifVende.current.value = values.rif.substring(0, 1);
      txtRifVende.current.value = values.rif.substring(2, 9);
      txtNomVende.current.value = values.nombre;
      selectResponsable(values.rif);
      setIdvendedr("'" + 'n.idvendedor = ' + values.idagente + "'");
    }

  };

  const catalogoProductoc = (ope) => (e) => {
    e.preventDefault();
    if (ope === 1) {
      setClientvende('cliente');
      setMostrar1(true);
    } else {
      setClientvende('vendedor');
      setMostrar1(true);
    }
  };

  const handleAceptaAlmacen = (values) => {
    setMostrar2(false);
    txtNombreAlmacen.current.value = values.descripcion;
    txtCodigoAlmacen.current.value = values.idalmacen;
    setIdalmacen(values.idalmacen);
  };

  const selectResponsable = (id) => {

    let campos = '*';
    let nomtab = 'agente';
    let nomid = 'rif';
    let nomid2 = clientvende;
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idagente > 0) {
            if (clientvende === 'cliente') {
              txtNomrespon.current.value = response.data.nombre;
              setIdclient("quote_literal(" + "'" + response.data.rif + "'" + ")");
              btnAcepta.current.focus();
            } else {
              txtNomVende.current.value = response.data.nombre;
              setIdvendedr("'" + ' and n.idvendedor = ' + response.data.idagente + "'");
              btnAcepta.current.focus();
            }
          } else {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ RIF y/o Cliente no Registrado !', icono: 'informacion' });
            txtRifrespon.current.value = '';
            txtNomrespon.current.value = '';
            txtRifVende.current.value = '';
            txtNomVende.current.value = '';
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const onChange = (e) => {

    if (e.target.name === 'nci') {
      setTipofic(e.target.value);
    } else if (e.target.name === 'desde') {
      if (e.target.value > moment(fechasistema).format('YYYY-MM-DD')) {
        setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !', icono: 'informacion' });
        txtDesde.current.value = moment(fechasistema).format('YYYY-MM-DD');
        txtDesde.current.focus()
      } else {
        setDesde("'" + moment(e.target.value).format('DD-MM-YYYY') + "'");
      }
    } else if (e.target.name === 'hasta') {
      setHasta("'" + moment(e.target.value).format('DD-MM-YYYY') + "'");
    }

  }

  const handleCliente = (e) => {
    e.preventDefault();
    if (e.which === 13 || typeof (e.which) === 'undefined') {
      if (e.target.value !== '') {
        selectResponsable(tiporif + e.target.value);
      }
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {

        if (props.op === 1) {

          if (props.report === "reportenotaentrega") {
            let tipo = 'NE';
            let paran = 'n.tipo = ';
            setTipon(tipo);
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
            setTituloc('LISTADO DE NOTAS DE ENTREGA');
            setTituid(tipo);
          } else if (props.report === "reportenotadebitos") {
            let tipo = 'ND';
            let paran = 'n.tipo = ';
            setTipon(tipo);
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
            setTituloc('LISTADO DE NOTAS DE DEBITO');
            setTituid(tipo);
          } else if (props.report === "reporteobsequio") {
            let tipo = 'NO';
            let paran = 'n.tipo = ';
            setTipon(tipo);
            setReport("'" + paran + "'" + "|| quote_literal(" + "'" + tipo + "'" + ")");
            setTituloc('LISTADO DE OBSEQUIO/DONACIÓN');
          } else if (props.report === "reportepedidos") {
            let paran = 'and n.idcliente > 0';
            setReport("'" + paran + "'");
            setTituid('PE');
            setTipon('PE');
            setTituloc('LISTADO DE PEDIDOS GENERADOS');
          } else if (props.report === "reportefacturas") {
            let paran = 'n.idfactura > 0';
            setReport("'" + paran + "'");
          }

          seleccionarRegistro(afiliado);
          setValestado(0);
          txtTodosEstados.current.checked = true;
          txtPorEstados.current.checked = false;

          if (props.report !== "reporteobsequio") {
            txtTodosDispo.current.checked = true;
            txtCanceladas.current.checked = false;
            txtDeudas.current.checked = false;
          }

          txtTodasFechas.current.checked = true;
          txtTodosCliente.current.checked = true;
          txtTodosVendedores.current.checked = true;

          if (props.report !== "reportenotadebitos") {
            txtTodosAlmacen.current.checked = true;
            txtPorAlmacen.current.checked = false;
          }

          setParacliente('');
          setDisponiblec('');
          setParafecha('');
          setDesde('');
          setHasta('');
          setTipofic('V');
          setOrdens('n.fecha');
          txtPorFechas.current.checked = false;
          txtPorCliente.current.checked = false;
          txtPorVendedor.current.checked = false;
          setHabilitado(false);
        } else {

          if (props.report !== "reporteobsequio") {
            txtTodosDispo.current.checked = false;
            txtCanceladas.current.checked = false;
            txtDeudas.current.checked = false;
          }

          txtTodasFechas.current.checked = false;
          txtTodosCliente.current.checked = false;

          txtPorCliente.current.checked = false;
          txtPorFechas.current.checked = false;

          txtTodosAlmacen.current.checked = false;
          txtPorAlmacen.current.checked = false;

          txtTodosVendedores.current.checked = false;
          txtPorVendedor.current.checked = false;

          setHabilitado(true);
        }

      }}
    >
      <Modal.Header className='azulGradiant2 header-modal'>
        <div className='fw-bold' style={{ color: "#fff" }}><h3>{props.report === 'reportefacturas' ? 'Imprimir Facturas' : props.report === "reportenotaentrega" ? 'Imprimir Notas de Entrega'
          : props.report === 'reportenotadebitos' ? 'Imprimir Notas de Debito' : props.report === 'reportepedidos' ? 'Imprimir Pedidos' : 'Imprimir Obsequio/Donación'}</h3></div>

        <a href='#' ref={btnSalir} disabled={botones.salir} onClick={cancelar} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === 'Exito.' ?
              cerrarModal() :
              setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
          }
          } />
        <MensajeSiNo mensaje={mensajesino}
          onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className='col-md-12 row mx-auto px-0'>

          <div className="row col-md-12 rounded mx-auto">

            {props.report === "reportenotaentrega" ? <div className='colfull col-pd-100 px-1 ml-auto'>
              <div className="form-check">
                <input className="form-check-input" name='general' ref={txtChekGeneral} onChange={onChekval} type="checkbox" value="" id="flexCheckChecked" />
                <label className="form-check-label" for="flexCheckChecked">
                  GENERAL
                </label>
              </div>
            </div> : <div><input type='hidden' ref={txtChekGeneral} value={false} /></div>}

            <div className={`${props.report === "reportenotaentrega" ? "colfull col-pd-300 px-3" : "colfull col-pd-300 px-3 ml-auto"}`}>
              <div className="input-group input-group-sm">
                <label
                  className="input-group-text"
                  id="inputGroup-sizing-sm"
                >
                  ORDENAR POR:
                </label>
                <select
                  className="form-control form-control-sm form-select fs-6 fw-bold"
                  ref={txtOrden}
                  name="orden"
                /* onChange={onChekval} */

                >
                  <option value="1">FECHA</option>
                  <option value="l.idagente">CLIENTES</option>
                  <option value="n.idvendedor">VENDEDOR</option>
                </select>
              </div>
            </div>

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
              <legend className="float-none m-0 w-auto fs-4 fw-bold">Fecha:</legend>

              <div className='col-2 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="tipoalmacen" value="1" ref={txtTodasFechas} onChange={onChekval} id="tipoalmacen" type="radio" />
                  <label className="form-check-label" for="exampleRadi1">
                    Todos
                  </label>
                </div>
              </div>

              <div className='col-2 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="tipoalmacen" value="2" ref={txtPorFechas} onChange={onChekval} id="tipoalmacen" type="radio" />
                  <label className="form-check-label" for="exampleRadi2">
                    Por Fecha
                  </label>
                </div>
              </div>

              <div className='col-7 row m-0'>

                <div className='col-6'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">DESDE:</label>
                    <input type="date" ref={txtDesde} disabled={inputalmacen === 0 ? true : false} name='desde' onChange={onChange} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  </div>
                </div>

                <div className='col-6'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">HASTA:</label>
                    <input type="date" ref={txtHasta} disabled={inputalmacen === 0 ? true : false} name='hasta' onChange={onChange} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  </div>
                </div>

              </div>

            </fieldset>

            {props.report !== "reporteobsequio" ? <fieldset className='row col-sm-12 d-flex justify-content-center border-azul rounded mb-1 mx-auto'>
              <legend className="float-none m-0 w-auto fs-4 fw-bold">Estatus del Pago:</legend>

              <div className='col-2'>
                <div className="form-check">
                  <input className="form-check-input" name="tipodisponible" value="1" ref={txtTodosDispo} onChange={onChekval} id="tipodisponible" type="radio" />
                  <label className="form-check-label" for="exampleRai1">
                    Todos
                  </label>
                </div>
              </div>

              <div className='col-3'>
                <div className="form-check">
                  <input className="form-check-input" name="tipodisponible" value="2" ref={txtCanceladas} onChange={onChekval} id="tipodisponible" type="radio" />
                  <label className="form-check-label" for="exampleRai2">
                    Canceladas
                  </label>
                </div>
              </div>

              <div className='col-3'>
                <div className="form-check">
                  <input className="form-check-input" name="tipodisponible" value="3" ref={txtDeudas} onChange={onChekval} id="tipodisponible" type="radio" />
                  <label className="form-check-label" for="exampleRai3">
                    Con Deudas
                  </label>
                </div>
              </div>

              <div className='col-2'>
                <div className="form-check">
                  <input className="form-check-input" name="tipodisponible" value="4" ref={txtAnuladas} onChange={onChekval} id="tipodisponible" type="radio" />
                  <label className="form-check-label" for="exampleRai4">
                    Anuladas
                  </label>
                </div>
              </div>

            </fieldset> : ''}

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
              <legend className="float-none m-0 w-auto fs-4 fw-bold">Cliente:</legend>

              <div className='col-2 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" disabled={valestado === 1 ? true : false} name="cliente" value="1" ref={txtTodosCliente} onChange={onChekval} id="cliente" type="radio" />
                  <label className="form-check-label" for="exampleRa1">
                    Todos
                  </label>
                </div>
              </div>

              <div className='col-2 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" disabled={valestado === 1 ? true : false} name="cliente" value="2" ref={txtPorCliente} onChange={onChekval} id="cliente" type="radio" />
                  <label className="form-check-label" for="exampleRa2">
                    Por Cliente
                  </label>
                </div>
              </div>

              <input type='hidden' ref={txtIdProducto} />

              <div className='col-7 mr-auto px-0'>
                <div className="input-group input-group-sm col-7 px-1 ml-auto">
                  <label className="input-group-text" id="inputGroup-sizing-sm">RIF:</label>
                  <select className="form-select col-3" ref={txtCbmrif} name='nci' onChange={onChange} aria-label="Default select example">
                    <option value="V">V</option>
                    <option value="E">E</option>
                    <option value="J">J</option>
                    <option value="P">P</option>
                    <option value="G">G</option>
                  </select>
                  <input type="text" ref={txtRifrespon} disabled={inputproducto === 1 ? false : true} onKeyUp={handleCliente} onBlur={handleCliente} className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  <button disabled={inputproducto === 1 ? false : true} type="button" onClick={catalogoProductoc(1)} className="btn btn-success"><i className="fas fa-search"></i></button>
                </div>
              </div>

              <div className='col-12 row m-0 py-3'>

                <div className='col-12'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">Nombre del Cliente:</label>
                    <input type="text" ref={txtNomrespon} disabled={true} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  </div>
                </div>

              </div>

            </fieldset>

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
              <legend className="float-none m-0 w-auto fs-4 fw-bold">Vendedor:</legend>

              <div className='col-pd-140 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="vendedor" value="1" ref={txtTodosVendedores} onChange={onChekval} id="vendedor" type="radio" />
                  <label className="form-check-label" for="exampleRa1">
                    Todos
                  </label>
                </div>
              </div>

              <div className='col-pd-176'>
                <div className="form-check">
                  <input className="form-check-input" name="vendedor" value="2" ref={txtPorVendedor} onChange={onChekval} id="vendedor" type="radio" />
                  <label className="form-check-label" for="exampleRa2">
                    Por Vendedor
                  </label>
                </div>
              </div>

              <input type='hidden' ref={txtIdProducto} />

              <div className='col-pd-405'>
                <div className="input-group input-group-sm px-1 col-pd-250 ml-auto">
                  <label className="input-group-text" id="inputGroup-sizing-sm">RIF:</label>
                  <select className="form-select col-3" ref={txtCbmrifVende} name='nci' onChange={onChange} aria-label="Default select example">
                    <option value="V">V</option>
                    <option value="E">E</option>
                    <option value="J">J</option>
                    <option value="P">P</option>
                    <option value="G">G</option>
                  </select>
                  <input type="text" ref={txtRifVende} disabled={valvende === 1 ? false : true} onKeyUp={handleCliente} onBlur={handleCliente} className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  <button disabled={valvende === 1 ? false : true} type="button" onClick={catalogoProductoc(2)} className="btn btn-success"><i className="fas fa-search"></i></button>
                </div>
              </div>

              <div className='col-12 row m-0 py-3'>

                <div className='col-12'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">Nombre del Vendedor:</label>
                    <input type="text" ref={txtNomVende} disabled={true} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  </div>
                </div>

              </div>

            </fieldset>

            {props.report === "reportenotaentrega" || props.report === "reportepedidos" || props.report === "reportefacturas" || props.report === "reporteobsequio" ? <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
              <legend className="float-none m-0 w-auto fs-4 fw-bold">Almacen:</legend>

              <div className='col-2 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="alamcen" value="1" ref={txtTodosAlmacen} onChange={onChekval} id="alamcen" type="radio" />
                  <label className="form-check-label" for="exampleRa1">
                    Todos
                  </label>
                </div>
              </div>

              <div className='col-2 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" name="alamcen" value="2" ref={txtPorAlmacen} onChange={onChekval} id="alamcen" type="radio" />
                  <label className="form-check-label" for="exampleRa2">
                    Por Almacen
                  </label>
                </div>
              </div>

              {/* <input type='hidden' ref={txtIdProducto} /> */}

              <div className='col-7 mr-auto px-0'>
                <div className="input-group input-group-sm col-7 px-1 ml-auto">
                  <label className="input-group-text" id="inputGroup-sizing-sm">CODIGO ALMACEN:</label>
                  <input type="text" ref={txtCodigoAlmacen} disabled={true} /* onKeyUp={handleCliente} onBlur={handleCliente} */ className="form-control text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  <button disabled={valalmacen === 1 ? false : true} type="button" onClick={() => setMostrar2(true)} className="btn btn-success"><i className="fas fa-search"></i></button>
                </div>
              </div>

              <div className='col-12 row m-0 py-3'>

                <div className='col-12'>
                  <div className="input-group input-group-sm">
                    <label className="input-group-text" id="inputGroup-sizing-sm">NOMBRE DEL ALMACEN:</label>
                    <input type="text" ref={txtNombreAlmacen} disabled={true} className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                  </div>
                </div>

              </div>

            </fieldset> : ''}

            <fieldset className='row col-sm-12 mx-auto border-azul rounded mb-1'>
              <legend className="float-none m-0 w-auto fs-4 fw-bold">Estado:</legend>

              <div className='col-2 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" disabled={inputproducto === 1 ? true : false} name="estado" value="1" ref={txtTodosEstados} onChange={onChekval} id="estado" type="radio" />
                  <label className="form-check-label" for="exampleRa1">
                    Todos
                  </label>
                </div>
              </div>

              <div className='col-2 mx-auto'>
                <div className="form-check">
                  <input className="form-check-input" disabled={inputproducto === 1 ? true : false} name="estado" value="2" ref={txtPorEstados} onChange={onChekval} id="estado" type="radio" />
                  <label className="form-check-label" for="exampleRa2">
                    Por Estado
                  </label>
                </div>
              </div>

              <div className='col-12 row m-0 py-2'>
                <div className='col-4 mr-auto px-1'>
                  <div class="input-group input-group-sm mb-1">
                    <label className="input-group-text" for="inputGroupSelect01">ESTADO</label>
                    <select className="form-select" id="inputGroupSelect01" ref={txtEstado} disabled={valestado === 1 ? false : true}>
                      {estado.map((item2, x) => (
                        <option key={x} value={item2.idestado}>
                          {" "}
                          {item2.nombre}{" "}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className='col-4 mr-auto px-1'>
                  <div class="input-group input-group-sm mb-1">
                    <label className="input-group-text" for="inputGroupSelect02">MUNICIPIO</label>
                    <select
                      className="form-select"
                      id="inputGroupSelect02"
                      ref={txtMunicipio}
                      disabled={valestado === 1 ? false : true}
                      onChange={handleMunicipioChange}
                    >
                      <option value="">Seleccione un municipio</option>
                      {municipio.map((item2, x) => (
                        <option key={x} value={item2.idmunicipio}>
                          {" "}
                          {item2.nombre}{" "}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className='col-4 mr-auto px-1'>
                  <div class="input-group input-group-sm mb-1">
                    <label className="input-group-text" for="inputGroupSelect03">CIUDAD</label>
                    <select
                      className="form-select"
                      id="inputGroupSelect03"
                      ref={txtCiudad}
                      disabled={valestado === 1 ? false : true}
                      onChange={handleCiudadChange}
                    >
                      <option value="">Seleccione una ciudad</option>
                      {ciudad.map((item2, x) => (
                        <option key={x} value={item2.idciudad}>
                          {" "}
                          {item2.nombre}{" "}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

            </fieldset>
          </div>

        </div>
      </Modal.Body >
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">

          <div className='col-md-4 ml-auto px-0 m-0 d-flex justify-content-end'>
            <button ref={btnAcepta} disabled={habilitado} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-primary mx-1"><i className="fas fa-print">  Imprimir</i></button>
            <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill mx-1"><i className="fas fa-window-close"> Cancelar</i></button>
          </div>
        </div>

      </Modal.Footer>

      <CatalogoCliente
        show={mostrar1}
        nomid={clientvende}
        onHideCancelar={() => setMostrar1(false)}
        onHideAceptaCatalogo={handleAceptaCliente}
      />
      <CatalogoAlmacen
        show={mostrar2}
        onHideCancelar={() => setMostrar2(false)}
        onHideAceptaCatalogo={handleAceptaAlmacen}
      />
    </Modal >
  );
}


// WEBPACK FOOTER //
// ./src/components/ventas/modalImprimirNDebitos.js